import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"

const Container = styled.div`
  position: relative;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* transition on opacity */
  opacity: 0;

  /* refer to StyledGridItem */
  /* https://www.styled-components.com/docs/advanced#referring-to-other-components */
  ${Container}:hover & {
    opacity: 0.6;
  }
`

const Title = styled.h2`
  margin: 1rem;
  line-height: 1.2;
`

const Image = styled(Img)`
  ${Container}:hover & {
    transform: scale(1.1);
  }
`

const GridItem = ({ image, altName }) => (
  <Container>
    <Image fluid={image} alt={altName}/>
    <Overlay>
      <Title></Title>
    </Overlay>
  </Container>
)

export default GridItem
